import { render } from "./ImpressumView.vue?vue&type=template&id=4423788e"
import script from "./ImpressumView.vue?vue&type=script&lang=js"
export * from "./ImpressumView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__